import React, { useState } from "react";
import { FormGroup, Button, Table, Input } from "reactstrap";
import ProvenirApi from "../../api/ProvenirApi";
import { useSideChannelSubscription } from "../../util/useSideChannel";
import Loader from "../Loader";
import Notification from "../Notification";

function EvaluateCreditCapacityField(props) {
    const {
        formContext,
        schema: { title },
        uiSchema: { "ui:readonly": readonly },
        formData,
        required,
        rawErrors,
        idSchema,
    } = props;

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState("");
    const { sideChannel } = formContext;
    const formObject = useSideChannelSubscription(sideChannel, 1) || {};

    const {
        clasificacionScore,
        cumpleCapacidadPago,
        cumpleEdadPlazo,
        cumpleMora30d,
        cumpleMora60d,
        cumpleMora90d,
        decisionFinal,
        motivosRechazoIdentificador,
        motivosRechazoMensaje,
        motivosRechazoRegla,
        motivosRechazoTipoRegla,
        apelarDecision,
    } = formData || {};

    const hasResults = clasificacionScore || decisionFinal;
    const hasSchemaErrors = rawErrors && rawErrors.length > 0;
    const showRequiredError = !readonly && !hasResults && (required || hasSchemaErrors);
    const showApelarDecision = decisionFinal === "RECHAZO";
    const showApelarError = showApelarDecision && !readonly && !apelarDecision;

    function handleApelarChange(value) {
        formContext.setFormDataValues({
            "informacionIntencionVinculacion.prestamos.evaluacionCapacidadCredito.apelarDecision": value,
        });
    }

    async function evaluate(e) {
        e.preventDefault();
        if (isLoading) return;

        setIsLoading(true);
        setError("");

        try {
            const { clients, caseLoanInfo } = formObject;
            const response = await ProvenirApi.evaluateCreditCapacity({ clients, caseLoanInfo });
            console.log("response", response);
            const responseSalida = response?.Data?.Provenir?.Salida || {};
            const motivos = responseSalida?.Motivos_Rechazo?.Motivo || {};

            formContext.setFormDataValues({
                "informacionIntencionVinculacion.prestamos.evaluacionCapacidadCredito.clasificacionScore": responseSalida?.clasificacionScore ?? "",
                "informacionIntencionVinculacion.prestamos.evaluacionCapacidadCredito.cumpleCapacidadPago": responseSalida?.cumpleCapacidadPago != null ? String(responseSalida.cumpleCapacidadPago) : "",
                "informacionIntencionVinculacion.prestamos.evaluacionCapacidadCredito.cumpleEdadPlazo": responseSalida?.cumpleEdadPlazo != null ? String(responseSalida.cumpleEdadPlazo) : "",
                "informacionIntencionVinculacion.prestamos.evaluacionCapacidadCredito.cumpleMora30d": responseSalida?.cumpleMora30d != null ? String(responseSalida.cumpleMora30d) : "",
                "informacionIntencionVinculacion.prestamos.evaluacionCapacidadCredito.cumpleMora60d": responseSalida?.cumpleMora60d != null ? String(responseSalida.cumpleMora60d) : "",
                "informacionIntencionVinculacion.prestamos.evaluacionCapacidadCredito.cumpleMora90d": responseSalida?.cumpleMora90d != null ? String(responseSalida.cumpleMora90d) : "",
                "informacionIntencionVinculacion.prestamos.evaluacionCapacidadCredito.decisionFinal": responseSalida?.decisionFinal ?? "",
                "informacionIntencionVinculacion.prestamos.evaluacionCapacidadCredito.motivosRechazoIdentificador": motivos?.Identificador ?? "",
                "informacionIntencionVinculacion.prestamos.evaluacionCapacidadCredito.motivosRechazoMensaje": motivos?.mensaje ?? "",
                "informacionIntencionVinculacion.prestamos.evaluacionCapacidadCredito.motivosRechazoRegla": motivos?.regla ?? "",
                "informacionIntencionVinculacion.prestamos.evaluacionCapacidadCredito.motivosRechazoTipoRegla": motivos?.tipoRegla ?? "",
            });
        } catch (err) {
            setError(err.message || "Error al evaluar capacidad de crédito.");
        }

        setIsLoading(false);
    }

    return (
        <>
            {error ? (
                <Notification color="danger">
                    <div>{error}</div>
                </Notification>
            ) : null}
            {!readonly ? (
                <FormGroup className="file-field" disabled={readonly || isLoading}>
                    <Button
                        id={idSchema?.decisionFinal?.$id}
                        className="btn btn-secondary"
                        onClick={(e) => evaluate(e)}
                    >
                        {isLoading ? <Loader /> : title}
                    </Button>
                    {showRequiredError ? (
                        <ul className="error-detail bs-callout bs-callout-info">
                            <li className="text-danger">es requerido</li>
                        </ul>
                    ) : null}
                </FormGroup>
            ) : null}
            {hasResults ? (
                <FormGroup>
                    <legend>{title}</legend>
                    <Table hover size="sm">
                        <tbody>
                            <tr><td>Clasificación Score</td><td>{clasificacionScore}</td></tr>
                            <tr><td>Cumple Capacidad de Pago</td><td>{cumpleCapacidadPago}</td></tr>
                            <tr><td>Cumple Edad Plazo</td><td>{cumpleEdadPlazo}</td></tr>
                            <tr><td>Cumple Mora 30d</td><td>{cumpleMora30d}</td></tr>
                            <tr><td>Cumple Mora 60d</td><td>{cumpleMora60d}</td></tr>
                            <tr><td>Cumple Mora 90d</td><td>{cumpleMora90d}</td></tr>
                            <tr><td>Decisión Final</td><td>{decisionFinal}</td></tr>
                            {motivosRechazoIdentificador ? (
                                <>
                                    <tr><td>Motivos Rechazo - Identificador</td><td>{motivosRechazoIdentificador}</td></tr>
                                    <tr><td>Motivos Rechazo - Mensaje</td><td>{motivosRechazoMensaje}</td></tr>
                                    <tr><td>Motivos Rechazo - Regla</td><td>{motivosRechazoRegla}</td></tr>
                                    <tr><td>Motivos Rechazo - Tipo Regla</td><td>{motivosRechazoTipoRegla}</td></tr>
                                </>
                            ) : null}
                            {showApelarDecision ? (
                                <tr>
                                    <td>Apelar la Decisión</td>
                                    <td>
                                        {readonly ? apelarDecision : (
                                            <>
                                                <Input
                                                    type="textarea"
                                                    value={apelarDecision || ""}
                                                    onChange={(e) => handleApelarChange(e.target.value)}
                                                    invalid={showApelarError}
                                                />
                                                {showApelarError ? (
                                                    <ul className="error-detail bs-callout bs-callout-info">
                                                        <li className="text-danger">es requerido</li>
                                                    </ul>
                                                ) : null}
                                            </>
                                        )}
                                    </td>
                                </tr>
                            ) : null}
                        </tbody>
                    </Table>
                </FormGroup>
            ) : null}
        </>
    );
}

export default EvaluateCreditCapacityField;